<template>
  <div class="inquiry_index">
    <div class="inquiry_title">
      <el-icon class="el-icon-edit-outline"></el-icon> 询报价
    </div>
    <div class="inquiry_form">

      <div class="inquiry_bar">
        船舶信息
      </div>

      <div class="inquiry_form_one" v-if="form.mmsi">
        <div class="inquiry_form_title">
          船舶MMSI
        </div>
        <div class="inquiry_form_input">
          {{ form.state !== 1 ? '*********' : form.mmsi }} <span style="color:#03a7d5;" v-if="form.state !== 1">【联系报价后可见】</span>
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          船舶名称 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          {{form.ship_name}} <span style="color:#03a7d5;" v-if="form.state !== 1">【联系报价后可见】</span>
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          船舶类型 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          {{form.ship_type}}
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          总吨
        </div>
        <div class="inquiry_form_input">
          {{form.gross_tonnage}}
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          载重 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          {{form.dwt}}
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          船籍港 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          {{form.home_port}}
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          航行区域 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          <span v-for="(item,index) in area_types" v-if="form.area!=null && index===form.area">{{item}}</span>
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          造船厂 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          {{ form.builder }}
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          建造年份 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          {{ form.build_year }}
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          所有人 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          {{ form.ship_owner }}
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          船级社 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          {{ form.classification_society }}
        </div>
      </div>

      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          <b>保险信息</b>
        </div>
        <div class="inquiry_form_input">

        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          保险起期 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          {{ new Date(form.insurance_begin*1000).toLocaleDateString()}}
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          保险止期 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          {{ new Date(form.insurance_stop*1000).toLocaleDateString()}}
        </div>
      </div>

      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          <b>其他信息</b>
        </div>
        <div class="inquiry_form_input">

        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          船舶证书
        </div>
        <div class="inquiry_form_input">
          <el-image
            v-for="(item,index) in form.shipcerts" :src="item" :key="index"
            style="height:1.5rem;border:1px solid #ddd;"
            :preview-src-list="form.shipcerts">
            <div slot="error" class="image-slot">
              <i class="el-icon-collection">{{item.substring(item.lastIndexOf(".")+1).toUpperCase()}}</i>
            </div>
          </el-image>
        </div>
      </div>

      <div class="inquiry_bar">
        安蓝风控评估
      </div>

      <div style="width:100%;float:left;height:5rem;">
        <div class="inquiry_risk_main_left">
          <div class="inquiry_risk_main_left_title">
            船舶估值
          </div>
          <div class="inquiry_risk_main_left_content">
            <span>{{ form && form.valuation ? form.valuation + ([1,3,4,"1","3","4"].indexOf(form.modeltype)>=0 ? '万美元' : '万元') : '无'}}</span>
          </div>
        </div>
        <div class="inquiry_risk_main_right">
          <div class="inquiry_risk_main_left_title">
            船舶评级
          </div>
          <div class="inquiry_risk_main_left_score">
            <span>{{form && form.risk_score ? form.risk_score : '无'}}</span>
          </div>
          <div class="inquiry_risk_main_left_star">
            <span v-if="form && form.risk_score">
              <el-rate
              v-model="form.risk_score"
              :colors="colors" disabled></el-rate>
            </span>
            <span v-else></span>
          </div>
        </div>
      </div>

      <div style="width:100%;float:left;">
        <div class="inquiry_risk_info_main">
          <p class="inquiry_risk_info_title">⚠ 风险提示 ：<span class="inquiry_risk_info_one" v-if="!form.risk_info || form.risk_info==null || form.risk_info==='{}'">无</span></p>
          <p class="inquiry_risk_info_one" v-if="form.risk_info && form.risk_info!=null && form.risk_info!='{}'" v-for="(value,key,index) in JSON.parse(form.risk_info)" :key="key"><span style="color:grey;">{{key+' : '}}</span> {{ value }}</p>
        </div>
      </div>

      <div class="inquiry_bar">
         询报价状态
        <span :style="'margin-left:1rem;color:'+stateColor[form.state]+';'">{{states[form.state]}}</span>
      </div>

      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          <b>投保人信息</b>
        </div>
        <div class="inquiry_form_input">

        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          姓名 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          {{ form.rfq_name }} <span style="color:#03a7d5;" v-if="form.state !== 1">【联系报价后可见】</span>
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          邮箱
        </div>
        <div class="inquiry_form_input">
          {{ form.rfq_email }} <span style="color:#03a7d5;" v-if="form.state !== 1">【联系报价后可见】</span>
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          手机 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          {{ form.rfq_phone }} <span style="color:#03a7d5;" v-if="form.state !== 1">【联系报价后可见】</span>
        </div>
      </div>

      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          <b>被保人信息</b>
        </div>
        <div class="inquiry_form_input">

        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          姓名 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          {{ form.insured_name }} <span style="color:#03a7d5;" v-if="form.state !== 1">【联系报价后可见】</span>
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          邮箱
        </div>
        <div class="inquiry_form_input">
          {{ form.insured_email }} <span style="color:#03a7d5;" v-if="form.state !== 1">【联系报价后可见】</span>
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          手机 <span class="inquiry_red_star">*</span>
        </div>
        <div class="inquiry_form_input">
          {{ form.insured_phone }} <span style="color:#03a7d5;" v-if="form.state !== 1">【联系报价后可见】</span>
        </div>
      </div>

      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          <b>保司信息</b>
        </div>
        <div class="inquiry_form_input">

        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          姓名
        </div>
        <div class="inquiry_form_input">
          <el-input size="small" placeholder="姓名称呼" v-model="form.insurance_name" :readonly="form.state > 0"></el-input>
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          邮箱
        </div>
        <div class="inquiry_form_input">
          <el-input size="small" placeholder="电子邮箱" v-model="form.insurance_email" :readonly="form.state > 0"></el-input>
        </div>
      </div>
      <div class="inquiry_form_one">
        <div class="inquiry_form_title">
          手机
        </div>
        <div class="inquiry_form_input">
          <el-input size="small" placeholder="联系手机号" v-model="form.insurance_phone" :readonly="form.state > 0"></el-input>
        </div>
      </div>

      <div class="inquiry_bar">
        保险产品
      </div>

      <div class="inquiry_form_one_title">
        保险产品
      </div>
      <div class="inquiry_form_one">
        {{ product.title }}
      </div>
      <div class="inquiry_form_one_title">
        主条款
      </div>
      <div class="inquiry_form_one">
        <p class="inquiry_form_one_tag" v-for="mitem in product.main_terms" :key="mitem.id" @click="showDetail('main',mitem.id)">{{mitem.title}}</p>
      </div>
      <div class="inquiry_form_one_title" v-if="product.additional_terms && product.additional_terms.length>0">
        附加额外条款
      </div>
      <div class="inquiry_form_one" v-if="product.additional_terms && product.additional_terms.length>0">
        <p class="inquiry_form_one_tag" v-for="aitem in product.additional_terms" :key="aitem.id" @click="showDetail('additional',aitem.id)">{{aitem.title}}</p>
      </div>
      <div class="inquiry_form_one_title" v-if="product.special_terms && product.special_terms.length>0">
        特殊约定
      </div>
      <div class="inquiry_form_one" v-if="product.special_terms && product.special_terms.length>0">
        <p class="inquiry_form_one_tag" v-for="sitem in product.special_terms" :key="sitem.id" @click="showDetail('special',sitem.id)">按照 <span style="text-decoration: underline;color:dodgerblue;">《{{sitem.title}}》</span> {{sitem.suffix}}</p>
      </div>
      <div class="inquiry_form_one_title" v-if="product.deductible_terms && product.deductible_terms.length>0">
        免赔责任
      </div>
      <div class="inquiry_form_one" v-if="product.deductible_terms && product.deductible_terms.length>0">
        <p class="inquiry_form_one_tag" v-for="ditem in product.deductible_terms" :key="ditem.id" @click="showDetail('deductible',ditem.id)">{{ditem.title}}</p>
      </div>

      <div class="inquiry_form_one" v-if="form.state < 1">
        <div class="inquiry_form_title">
          <b>报价详情</b>
        </div>
        <div class="inquiry_form_input">
          <el-switch
            v-model="isonline"
            active-text="线上报价"
            inactive-text="线下报价"
            inactive-color="#67c23a">
          </el-switch>
        </div>
      </div>
      <div v-if="form.state < 1 && isonline">
        <div class="inquiry_form_one">
          <div class="inquiry_form_title">
            费率 ( % )
          </div>
          <div class="inquiry_form_input">
            <el-input-number controls-position="right" :min="0" :max="100" :step="0.1" v-model="form.insurance_rate" autocomplete="false"/>
          </div>
        </div>
        <div class="inquiry_form_one">
          <div class="inquiry_form_title">
            保额 ( 元 )
          </div>
          <div class="inquiry_form_input">
            <el-input-number controls-position="right" :min="0" :step="10000" v-model="form.insurance_coverage" autocomplete="false"/>
          </div>
        </div>
        <div class="inquiry_form_one">
          <div class="inquiry_form_title">
            付款期限
          </div>
          <div class="inquiry_form_input">
            <el-input v-model="form.insurance_payment_method_deadline" autocomplete="false"/>
          </div>
        </div>
        <div class="inquiry_form_one">
          <div class="inquiry_form_title">
            赔付地点
          </div>
          <div class="inquiry_form_input">
            <el-input v-model="form.insurance_place" autocomplete="false"/>
          </div>
        </div>
        <div class="inquiry_form_one">
          <div class="inquiry_form_title">
            付款约定
          </div>
          <div class="inquiry_form_input">
            <el-input type="textarea" rows="2" v-model="form.insurance_payment_agreement" autocomplete="false"/>
          </div>
        </div>
      </div>

      <div v-if="form.state > 0">
        <div class="inquiry_form_one">
          <div class="inquiry_form_title">
            <b>报价详情</b>
          </div>
          <div class="inquiry_form_input">
            <span style="color:#03a7d5;">{{ form.insurance_coverage === 0 ? '线下报价' : '' }}</span>
          </div>
        </div>
        <div v-if="form.insurance_coverage > 0">
          <div class="inquiry_form_one">
            <div class="inquiry_form_title">
              费率 ( % )
            </div>
            <div class="inquiry_form_input">
              {{ form.insurance_rate || '无' }}
            </div>
          </div>
          <div class="inquiry_form_one">
            <div class="inquiry_form_title">
              保额 ( 元 )
            </div>
            <div class="inquiry_form_input">
              {{ form.insurance_coverage || '无' }}
            </div>
          </div>
          <div class="inquiry_form_one">
            <div class="inquiry_form_title">
              付款期限
            </div>
            <div class="inquiry_form_input">
              {{ form.insurance_payment_method_deadline || '无' }}
            </div>
          </div>
          <div class="inquiry_form_one">
            <div class="inquiry_form_title">
              赔付地点
            </div>
            <div class="inquiry_form_input">
              {{ form.insurance_place || '无' }}
            </div>
          </div>
          <div class="inquiry_form_one">
            <div class="inquiry_form_title">
              付款约定
            </div>
            <div class="inquiry_form_input">
              {{ form.insurance_payment_agreement || '无' }}
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="inquiry_bottom">
      <el-button :type="isonline ? 'primary' : 'success'" style="width:90%;margin:0 5%;float:left;" @click="insuranceSubmit" v-if="form.state===0">{{ isonline ? '立即提交报价' : '解锁联系方式' }}</el-button>
      <el-tag type="danger" style="width:90%;margin:0 5%;float:left;text-align:center;" v-if="form.state===1">已投保</el-tag>
      <el-tag type="info" style="width:90%;margin:0 5%;float:left;text-align:center;" v-if="form.state===2">已取消</el-tag>
    </div>
    <el-dialog
      :title="dtypes[dtype]"
      :visible.sync="detailDialogVisible" fullscreen>
      <h3>《{{ detail.title }}》</h3>
      <div v-html="detail.content"></div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="detailDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { getDomain,insuranceOrderQuoteGet,updateInsuranceOrderQuoteUpdate,getInsuranceProductsById,insuranceMainTermsById,insuranceAdditionalTermsById,insuranceSpecialTermsById,insuranceDeductibleTermsById } from '../../api/api'
  import { getJsonStorage } from "../../util/storage";

  export default {
    name: "InquiryAdd",
    data() {
      return {
        oid:this.$route.query.oid,
        domain:getDomain(),
        mains:[],
        additionals:[],
        keyword:'',
        ktimeout:null,
        ksearching:false,
        ships:[],
        dialogVisible:false,
        area_types:['内河','远洋','沿海'],
        states:['待报价','已报价','已取消'],
        stateColor:['#59c2e4','#f1c16b','#8f8f8f'],
        colors:['red','orange','#59c2e4'],
        imgs:[],
        form:{
          ship_name:null,
          mmsi:null,
          dwt:null,
          gross_tonnage:null,
          area:null,
          ship_owner:null,
          ship_type:null,
          home_port:null,
          build_year:null,
          valuation:null,
          classification_society:null,
          insurance_begin:new Date().valueOf(),
          insurance_stop: new Date().valueOf()+86400000*365,
          shipcerts:[],
          rfq_name:null,
          rfq_email:null,
          rfq_phone:null,
          modeltype:null,
          risk_info:'{}'
        },
        isonline:true,
        maxsize:1024*1024*10,
        product:{},
        dtype:'',
        detail:{},
        detailDialogVisible:false,
        dtypes:{'main':'主险','additional':'附加险','special':'特别约定','deductible':'免赔条款'},
        user: getJsonStorage('rfq_user') || {}
      }
    },
    mounted() {
      this.getInsuranceOrder();
    },
    methods: {
      getInsuranceOrder(){
        insuranceOrderQuoteGet(this.oid).then(ores => {
          if(ores && ores.status===0){
            ores.data.shipcerts = JSON.parse(ores.data.shipcerts);
            this.form = JSON.parse(JSON.stringify(ores.data));
            getInsuranceProductsById(this.form.insurance_products).then(res => {
              if(res && res.status === 0 && res.data){
                this.product = res.data;
                if(this.user){
                  let form = JSON.parse(JSON.stringify(this.form));
                  form.insurance_name = this.user.user_realname || this.user.nickname || this.user.username;
                  form.insurance_email = this.user.email;
                  form.insurance_phone = this.user.phone;
                  this.form = form;
                }
              }
            });
          }else{
            this.$router.push('/quote/index');
          }
        });
      },
      insuranceSubmit(){
        if(this.isonline){
          if(this.form.insurance_rate==null || this.form.insurance_rate <= 0){
            this.$message.warning("请填写费率");
            return;
          }
          if(this.form.insurance_coverage==null || this.form.insurance_coverage <= 0){
            this.$message.warning("请填写保额");
            return;
          }
        }
        let params = JSON.parse(JSON.stringify(this.form));
        params['shipcerts'] = JSON.stringify(params['shipcerts']);
        params['insurance_main_terms'] = JSON.stringify(params['insurance_main_terms']);
        params['insurance_additional_terms'] = JSON.stringify(params['insurance_additional_terms']);
        params['insurance_specials'] = JSON.stringify(params['insurance_specials']);
        params['insurance_deductible'] = JSON.stringify(params['insurance_deductible']);
        updateInsuranceOrderQuoteUpdate({...params,state:1}).then(res=>{
          if(res && res.status === 0){
            this.getInsuranceOrder();
          }
        });
      },
      showDetail(dtype,id){
        this.dtype = dtype;
        switch(dtype){
          case 'main':
            insuranceMainTermsById(id).then(res => {
              if(res && res.status === 0){
                this.detail = res.data;
                this.detailDialogVisible = true;
              }
            });
            break;
          case 'additional':
            insuranceAdditionalTermsById(id).then(res => {
              if(res && res.status === 0){
                this.detail = res.data;
                this.detailDialogVisible = true;
              }
            });
            break;
          case 'special':
            insuranceSpecialTermsById(id).then(res => {
              if(res && res.status === 0){
                this.detail = res.data;
                this.detailDialogVisible = true;
              }
            });
            break;
          case 'deductible':
            insuranceDeductibleTermsById(id).then(res => {
              if(res && res.status === 0){
                this.detail = res.data;
                this.detailDialogVisible = true;
              }
            });
            break;
          default:
            break;
        }
      }
    }
  }
</script>

<style scoped>
  .inquiry_index {
    top: 6vh;
    left: 0;
    position: absolute;
    height: 94vh;
    width: 100%;
    margin: 0;
    background-color: #fefefe;
    overflow-y: scroll;
  }
  .inquiry_title {
    height:2rem;
    line-height:2rem;
    text-indent: .5rem;
    font-size:.95rem;
    color:#03a7d5;
  }
  .inquiry_bottom {
    width:100%;
    position:absolute;
    bottom:0;
    height:4rem;
    line-height:4rem;
    border-top:1px #ddd dashed;
  }
  .inquiry_form {
    height:79vh;
    overflow-y: scroll;
  }
  .inquiry_form_one {
    float:left;
    min-height:1.2rem;
    line-height:1.2rem;
    width:90%;
    margin:.5rem 5%;
  }
  .inquiry_form_title {
    width:20%;
    float:left;
    font-size:.8rem;
    color:#666;
    height:1.2rem;
    line-height:1.2rem;
  }
  .inquiry_form_input {
    margin-left:3%;
    width:75%;
    float:left;
    min-height:1.2rem;
    line-height:1.2rem;
    font-size:.8rem;
  }
  .inquiry_media_box {
    width:100%;
    height:5rem;
    overflow:hidden;
  }
  .inquiry_media_one {
    height:5rem;
    width:20%;
    margin:.5rem 5%;
  }
  .inquiry_form_one_title {
    float:left;
    font-size:.8rem;
    color:#03a7d5;
    height:1.2rem;
    line-height:1.2rem;
    text-indent: 1rem;
  }
  .inquiry_ships_main {
    position: absolute;
    top:0;
    left:2%;
    width:96%;
    height:94vh;
    background:rgba(255,255,255,0.95);
    z-index:999;
  }
  .inquiry_ships_title {
    height:2rem;
    line-height:2rem;
    font-size:1rem;
    text-indent: .5rem;
  }
  .inquiry_ships_one {
    height:6rem;
    width:96%;
    margin-left:2%;
    border-top:1px dashed #ccc;
  }
  .inquiry_ships_line {
    width:100%;
    float:left;
    height:1.5rem;
    line-height:1.5rem;
    font-size:.8rem;
    color:grey;
  }
  .inquiry_ships_half_line {
    width:49%;
    float:left;
    height:1.5rem;
    line-height:1.5rem;
    font-size:.8rem;
    color:grey;
  }
  .inquiry_red_star {
    color:red;
  }
  .inquiry_form_one_tag {
    max-width:100%;
    font-size:.8rem;
    border:1px dashed #0063c8;
    border-radius:.3rem;
    padding:.3rem;
    background-color:#fafafa;
  }
  .inquiry_bar {
    width:100%;
    float:left;
    height:1.8rem;
    line-height:1.8rem;
    background-color:#eee;
    font-size:.95rem;
    font-weight:bold;
    text-indent: 1rem;
    border-top:1px solid #ddd;
    border-bottom:1px solid #ddd;
    margin:1vh 0;
  }
  .inquiry_risk_main_left {width:41%;margin:0 6%;float:left;}
  .inquiry_risk_main_right {width:41%;float:left;}
  .inquiry_risk_main_left_title {width:100%;height:2rem;line-height:2rem;float:left;text-align:center;font-size:.9rem;}
  .inquiry_risk_main_left_content {width:100%;height:3rem;line-height:3rem;float:left;text-align:center;color:dodgerblue;}
  .inquiry_risk_main_left_score {width:100%;height:1.5rem;line-height:1.5rem;float:left;text-align:center;color:dodgerblue;}
  .inquiry_risk_main_left_star {width:100%;height:1.5rem;line-height:1.5rem;float:left;text-align:center;color:dodgerblue;}
  .inquiry_risk_info_main {width:90%;margin:0 4%;padding:0 1%;border-radius:.5rem;border:1px solid red;background-color:#fcefee;font-size:.85rem;}
  .inquiry_risk_info_title {text-indent:.5rem;height:1.5rem;line-height:1.5rem;margin:0;color:red;}
  .inquiry_risk_info_one {text-indent:.5rem;height:1.5rem;line-height:1.5rem;margin:0;}
</style>



// WEBPACK FOOTER //
// src/components/quote/review.vue